import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, ComponentRef } from "@angular/core";
import { CluLockscreenComponent } from "./clu-lockscreen.component";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
    providedIn: 'root'
})
export class CluLockscreenService {
    componentRef: ComponentRef<CluLockscreenComponent> | null = null;

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private appRef: ApplicationRef,
        private matDialog: MatDialog,
        private injector: Injector
    ) { }

    showLockscreen(options: { LockscreenMode: LOCKSCREEN_MODE }) {
        return new Promise<string>((resolve, reject) => {
            this.matDialog.open(CluLockscreenComponent, {
                autoFocus: false, 
                disableClose: true, 
                data: { lockscreenMode: options.LockscreenMode } 
            }).afterClosed().subscribe((result?: any) => {
                resolve(result);
            });
        });
    }

    hideLockscreen() {
        if (!this.componentRef) { return; }
        this.appRef.detachView(this.componentRef.hostView);
        this.componentRef.destroy();
        this.componentRef = null;
    }
}

export enum LOCKSCREEN_MODE {
    LOCK_SESSION = 1,
    ASK_FOR_PERMISSION = 2
}